export const REDIRECT_STORAGE_KEY = 'redirectLink';
export const REDIRECT_LOGOUT_KEY = 'redirectLogout';
export const NEXT_PARAMETER_NAME = 'next';
export default {
  REDIRECT_STORAGE_KEY,
  REDIRECT_LOGOUT_KEY,
  NEXT_PARAMETER_NAME
};
